import React from 'react';

const CopyIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none" { ...rest }>
      <path d="M13.8 8.59385H4.8C3.8073 8.59385 3 9.40115 3 10.3938V19.3938C3 20.3865 3.8073 21.1938 4.8 21.1938H13.8C14.7927 21.1938 15.6 20.3865 15.6 19.3938V10.3938C15.6 9.40115 14.7927 8.59385 13.8 8.59385Z" fill="#909195"/>
      <path d="M19.2 3.19385H10.2C9.72261 3.19385 9.26477 3.38349 8.92721 3.72106C8.58964 4.05862 8.4 4.51646 8.4 4.99385V6.79385H15.6C16.0774 6.79385 16.5352 6.98349 16.8728 7.32106C17.2104 7.65862 17.4 8.11646 17.4 8.59385V15.7938H19.2C19.6774 15.7938 20.1352 15.6042 20.4728 15.2666C20.8104 14.9291 21 14.4712 21 13.9938V4.99385C21 4.51646 20.8104 4.05862 20.4728 3.72106C20.1352 3.38349 19.6774 3.19385 19.2 3.19385Z" fill="#909195"/>
    </svg>
  );
};

export default CopyIcon;